<cadastrar-empresa [tiposEmpresa]=tiposEmpresa titulo="Gestão de Parcerias"></cadastrar-empresa>
